import { render } from "./second.vue?vue&type=template&id=20c7afa6&scoped=true"
import script from "./second.vue?vue&type=script&lang=js"
export * from "./second.vue?vue&type=script&lang=js"

import "./second.vue?vue&type=style&index=0&id=20c7afa6&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c7afa6"]])

export default __exports__